import { render, staticRenderFns } from "./editSafePassword.vue?vue&type=template&id=0d32ff82"
import script from "./editSafePassword.vue?vue&type=script&lang=js"
export * from "./editSafePassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports